// extracted by mini-css-extract-plugin
module.exports = {"opreation-button":"opreation-button-69fdab8539a23c858a46b5f74847bdc8"};